import React from "react";
import { styled } from "@mui/material/styles";
import MuiButton from "@mui/material/Button";

import { ButtonProps } from "./Button.props";
import { CircularProgress } from "@mui/material";

const CustomButton = styled(MuiButton, {
  shouldForwardProp: (prop) => prop !== "buttonSize",
})<{ buttonSize?: "s" | "m" | "l" }>(({ buttonSize }) => ({
  padding:
    buttonSize === "s" ? "0px 20px" : buttonSize === "m" ? "0px 25px" : "0",
  height: buttonSize === "s" ? "40px" : buttonSize === "m" ? "50px" : "0px",
  borderRadius: "10px",
  fontWeight: 600,
  lineHeight: 0,
  whiteSpace: "nowrap",
  boxShadow: "none",
  "&:hover": {
    boxShadow: "none",
    opacity: 0.7,
  },
}));

export const Button: React.FC<ButtonProps> = (props) => {
  const { children, buttonSize = "s", isLoading, ...otherProps } = props;
  return (
    <CustomButton buttonSize={buttonSize} {...otherProps}>
      {isLoading == true ? <CircularProgress color="inherit" /> : children}
    </CustomButton>
  );
};
